// extracted by mini-css-extract-plugin
export default {"App":"TestApp_App__aJM8A","container":"TestApp_container__bUwX3"};